<template>
  <card>
    <!-- Card header -->
    <h3 slot="header" class="mb-0">Edit Project Type - {{ model.project_type }}</h3>
    <div class="text-right">
    </div>
    <form class="needs-validation"
          @submit.prevent="submit">

      <div class="form-row">
        <b-col md="12">
          <base-input label="Project Type"
                      name="Project Type"
                      placeholder="Project Type"
                      v-model="model.project_type" required>
          </base-input>
        </b-col>
      </div>

      <div class="form-row">
        <b-col md="4">
          <b-form-checkbox
            id="Active-Status"
            v-model="model.active_status"
            name="Active-Status"
            value="1"
            unchecked-value="0">
            <b>Active Status</b>
          </b-form-checkbox>
        </b-col>
      </div>
      <br>

      <base-button type="primary" @click="createData()" v-if="button_access.edit_button == 'YES'">Update Project Type</base-button>
      <base-button type="primary" @click="$router.back()">Cancel</base-button>
      <!-- <div>
        <br>
        <h5 class="text-danger"> Note : <br><br>
                <i>
                1. By Default all Date is set to "TODAY.
                </i>
                <br>
                <i>
                2. Developer Progress % is set to "0 %" By Default.
                </i>
        </h5>
      </div> -->
    </form>
  </card>
</template>
<script>
  import BaseSlider from '@/components/BaseSlider'
  import {LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate} from '@/assets/js/config.js'
  import axios from 'axios'
  import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js'

  export default {
    mixins: [ErrorFunctionMixin],
    components: {
      BaseSlider
    },
    created()
    {
      var currentDate = getcurrentDate()
      this.getData()
    },
    data() {
      return {
        model: {
          project_type_id: null,
          project_type: null,
          active_status: 1,
        },
        abc: '100',
         button_access: {
          edit_button: null,
        },
      }
    },
    methods: {
      getData()
      {
        this.model.project_type_id = this.$route.params.id
        var project_type_access = JSON.parse(window.localStorage.getItem('project_type_access'))
        this.button_access.edit_button = project_type_access.access_edit


        axios.get(apiDomain + 'setup/project_type/' + this.model.project_type_id,  { headers: getHeader() })
        .then ( response => {
          console.log(response.data)
          if (response.status === 200)
          {
              this.model.project_type = response.data.data[0].project_type
              this.model.active_status = response.data.data[0].active_status
          }
        })
        .catch ( error => {
          console.log(error.response.data.errors)
          this.errorFunction(error, "Create New Project Type")
        });
      },
      createData(){
        if ( !this.model.project_type )
        {
          this.$notify({
            message:
              '<b>Invalid Input : All Column are Mandatory in Create New Project Type </b> - These field are required.',
            timeout: 10000,
            icon: 'ni ni-bulb-61',
            type: 'danger',
          });
        }
        else
        {
          axios.put(apiDomain + 'setup/project_type/' + this.model.project_type_id, this.model, { headers: getHeader() })
          .then ( response => {
            if (response.status === 200)
            {
                this.$notify({
                message:
                  '<b>Edit Project Type: ' + this.model.project_type + '</b> - Successfully Updated.',
                timeout: 10000,
                icon: 'ni ni-bell-55',
                type: 'default',
                });
                this.$router.back()
            }
          })
          .catch ( error => {
            console.log(error.response.data.errors)
            this.errorFunction(error, "Create New Project Type")
          });
        }
      },
    }
  }
</script>
<style>
</style>
